/**
 * @param {Object.<string, *>} query The parts of the query to build.
 * @return {string} The constructed string (including the beginning ?) or an empty string if query was empty.
 */
export const queryToString = (query = undefined) => {
  if (!query) return '';

  const joined = Object.entries(query ?? {})
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => typeof value === 'boolean' ? key : `${key}=${value}`)
    .join('&');

  return `${joined.length ? '?' : ''}${joined}`;
};